import { render } from "./SupervisorManagement.vue?vue&type=template&id=b22b9c52"
import script from "./SupervisorManagement.vue?vue&type=script&lang=js"
export * from "./SupervisorManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__